import React, {createContext, useContext, ReactNode} from 'react';

type FeatureFlags = {
  [key: string]: boolean;
};

interface NavFFContextValue {
  navFFstate: FeatureFlags;
}

const NavFFContext = createContext<NavFFContextValue | undefined>(undefined);

export const NavFeatureFlagProvider: React.FC<{children: ReactNode; navFFstate: FeatureFlags}> = ({
  children,
  navFFstate,
}) => {
  return <NavFFContext.Provider value={{navFFstate}}>{children}</NavFFContext.Provider>;
};

export const useNavFFContext = (): NavFFContextValue => {
  const context = useContext(NavFFContext);
  if (!context) {
    throw new Error('useNavFFContext must be used within a NavFeatureFlagProvider');
  }
  return context;
};
